/**
 * Route: /notes — R5/NO + Story 5.1 (Notizen-System UI)
 *
 * Globale Notes-Uebersicht (alle Notizen des Users ueber Hotspots,
 * Standortgeber/Kontakte und Konto hinweg), Referenz notes.html.
 * Nav-Eintrag: Sektion "Uebersicht" (layouts/nav.ts, id 'notes').
 */
import { createFileRoute } from '@tanstack/react-router'
import { NotesOverviewPage } from '../features/notes/NotesOverviewPage'

export const Route = createFileRoute('/_auth/notes')({
  component: NotesOverviewPage,
})
